import Banner from '../../elements/Banner';
import QuoteBanner from '../Quotes/QuoteBanner';
import wave1 from '../../assets/img/wave1.svg';
import wave2 from '../../assets/img/wave2.svg';
import NursesFilters from './Utils/NursesFilters';
import nurse1 from '../../assets/img/home/nurse1.png';
import nurse2 from '../../assets/img/home/nurse2.png';
import CompaniesCarrousel from '../Companies/CompaniesCarrousel';
import BannerSlider from 'elements/BannerSlider';

import { RiCustomerService2Line } from "react-icons/ri";
import { LiaUserNurseSolid } from "react-icons/lia";
import { RiShieldCrossLine } from "react-icons/ri";
import { HiOutlineHomeModern } from "react-icons/hi2";
import { TfiLocationPin } from "react-icons/tfi";
import { GiCheckMark } from "react-icons/gi";
import { Button } from '@mui/material';
import { Helmet } from 'react-helmet';

const homeSchema = {
    '@context': 'https://schema.org',
    '@graph': [
        {
            '@type': 'FAQPage',
            mainEntity: [
                {
                    '@type': 'Question',
                    name: '¿Qué tipo de heridas tratan las enfermeras especialistas?',
                    acceptedAnswer: { '@type': 'Answer', text: 'Úlceras por presión, pie diabético, úlceras venosas y arteriales, ostomías, terapia VAC, heridas postquirúrgicas, retiro de puntos y curaciones simples.' }
                },
                {
                    '@type': 'Question',
                    name: '¿En qué comunas de Chile hay enfermeras especializadas en heridas disponibles?',
                    acceptedAnswer: { '@type': 'Answer', text: 'Contamos con enfermeras en la Región Metropolitana, Valparaíso, Biobío, La Araucanía, O\'Higgins y otras regiones. Usa nuestro buscador para encontrar disponibilidad en tu comuna.' }
                },
                {
                    '@type': 'Question',
                    name: '¿Cómo contacto a una enfermera especialista en heridas a domicilio?',
                    acceptedAnswer: { '@type': 'Answer', text: 'Desde el perfil de cada profesional puedes enviarle un mensaje interno o contactarla por WhatsApp si tiene el plan preferente. Solo necesitas crear una cuenta gratuita.' }
                }
            ]
        },
        {
            '@type': 'BreadcrumbList',
            itemListElement: [
                { '@type': 'ListItem', position: 1, name: 'Inicio', item: 'https://especialistaenheridas.cl/' },
                { '@type': 'ListItem', position: 2, name: 'Buscador de Enfermeras', item: 'https://especialistaenheridas.cl/enfermeras' },
                { '@type': 'ListItem', position: 3, name: 'Preguntas Frecuentes', item: 'https://especialistaenheridas.cl/preguntas-frecuentes' }
            ]
        }
    ]
};

export default function Home(props: any) {
    return (
    <>
    <Helmet>
        <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
    </Helmet>


    <div className='header_container'>
        <div className='header_content'>
            <div className='header_title'>
                <h2>Encuentra tu enfermera a domicilio para cualquier procedimiento clínico.</h2>
                <h3>Curaciones, inyecciones, retiro de puntos y más. Conecta con la especialista ideal en tu comuna.</h3>
            </div>
            <QuoteBanner />
            <div className='header_search'>
                <NursesFilters />
            </div>
        </div>
        <div className='header_box'>
            <img src={wave2} alt="" className='waves wave2' />
            <img src={wave1} alt="" className='waves wave1' />
        </div>
    </div>

    <div className='sections_container'>
        <section className='section1'>
            <img src={nurse1} alt='nurse1' />
            <h2>Enfermeras especialistas a domicilio</h2>
            <span className='text_w_background'>a lo largo de chile</span>

            <p className='text_1'><b>Especialistadeheridas.cl</b> te conecta con enfermeras especializadas en curación de heridas, listas para atenderte a domicilio en diversas comunas a lo largo de Chile. Contamos con profesionales acreditadas y comprometidas con la calidad, la seguridad y la eficiencia en cada atención, contribuyendo a mejorar tu salud y bienestar.</p>

            <p className='text_2'>Confía en <span className='highlight_text'>Especialistadeheridas.cl</span> para el cuidado profesional de tus heridas, donde y cuando más lo necesitas.</p>
        </section>



        
        <section className='section2'>
            <h2 className='section_title'>¿Por qué elegirnos?</h2>
            <p style={{ textAlign: 'center', color: '#6b7280', marginTop: '8px', marginBottom: '0', fontSize: '16px' }}>
                Profesionales certificadas, atención a domicilio y cobertura en todo Chile.
            </p>
            <div className='items_container'>
                <div className='item_box'>
                    <div className='item_box_header'>
                        <div className='item_box_icon'><RiCustomerService2Line size={24} /></div>
                        <div>
                            <h2>Atención Personalizada</h2>
                            <span>Según tu necesidad</span>
                        </div>
                    </div>
                    <p>Cada paciente recibe un plan de atención único, adaptado a sus necesidades específicas y a la complejidad de su herida, brindando un tratamiento eficaz y personalizado.</p>
                </div>

                <div className='item_box'>
                    <div className='item_box_header'>
                        <div className='item_box_icon'><LiaUserNurseSolid size={28} /></div>
                        <div>
                            <h2>Enfermeras Especializadas</h2>
                            <span>Certificadas & acreditadas</span>
                        </div>
                    </div>
                    <p>Todas nuestras enfermeras cuentan con certificaciones especializadas en curación de heridas, garantizando un tratamiento profesional y de alta calidad.</p>
                </div>

                <div className='item_box'>
                    <div className='item_box_header'>
                        <div className='item_box_icon'><RiShieldCrossLine size={24} /></div>
                        <div>
                            <h2>Cuidado Preventivo</h2>
                            <span>& educación al paciente</span>
                        </div>
                    </div>
                    <p>Nuestras enfermeras no solo tratan la herida, sino que también educan al paciente y su familia en el cuidado preventivo para evitar complicaciones.</p>
                </div>

                <div className='item_box'>
                    <div className='item_box_header'>
                        <div className='item_box_icon'><HiOutlineHomeModern size={24} /></div>
                        <div>
                            <h2>Atención a Domicilio</h2>
                            <span>En la comodidad de tu hogar</span>
                        </div>
                    </div>
                    <p>Evita desplazamientos y tiempos de espera. Nuestras especialistas llevan la atención médica a tu hogar, en un ambiente cómodo y seguro.</p>
                </div>

                <div className='item_box'>
                    <div className='item_box_header'>
                        <div className='item_box_icon'><TfiLocationPin size={24} /></div>
                        <div>
                            <h2>Red Nacional</h2>
                            <span>A lo largo de Chile</span>
                        </div>
                    </div>
                    <p>Con cobertura en muchas comunas, accede a profesionales con amplia experiencia en múltiples regiones de Chile, facilitando atención especializada en distintas localidades.</p>
                </div>
            </div>

        </section>

        <Banner />

        <BannerSlider section="slider-home" />

        <section className='section3'>
            <img src={nurse2} alt='nurse2' />
            <h2>¿Te dedicas a la curación avanzada de heridas?</h2>
            <span className='text_w_background'>Ayuda a más personas a encontrarte.</span>

            <div className='section_content'>
                <div className='section_list_item'>
                    <GiCheckMark size={22} color='#135095' />
                    <p className='text_3'>En <b>especialistaenheridas.cl</b>, queremos facilitar el acceso a profesionales como tú, especialistas en curación avanzada de heridas.</p>
                </div>

                <div className='section_list_item'>
                    <GiCheckMark size={22} color='#135095' />
                    <p className='text_3'>Al crear tu perfil, aumentas tu presencia online y brindas a tus pacientes una manera fácil y rápida de acceder a una atención confiable y especializada.</p>
                </div>

                <div className='section_list_item'>
                    <GiCheckMark size={22} color='#135095' />
                    <p className='text_3'>Sé parte de una red colaborativa de enfermeras especialistas, donde todas apoyan la difusión y crecimiento de esta comunidad, potenciando la visibilidad y alcance de cada profesional en curación avanzada.</p>
                </div>

                <div className='section_list_item'>
                    <GiCheckMark size={22} color='#135095' />
                    <p className='text_3'>Si no eres especialista en heridas, también puedes crear tu perfil como <b>enfermera general</b> para ofrecer procedimientos básicos como retiro de puntos, curaciones simples, inyecciones intramusculares, sueroterapia y administración de medicamentos.</p>
                </div>

                <Button
                    className='register_button'
                    fullWidth
                    variant='contained'
                    href='/login'
                >
                    REGISTRARME
                </Button>
            </div>
        </section>

        <CompaniesCarrousel />
    </div>

    
    </>
    )
}